var a = (r, e, o) => new Promise((u, m) => {
  var s = (t) => {
    try {
      i(o.next(t));
    } catch (n) {
      m(n);
    }
  }, c = (t) => {
    try {
      i(o.throw(t));
    } catch (n) {
      m(n);
    }
  }, i = (t) => t.done ? u(t.value) : Promise.resolve(t.value).then(s, c);
  i((o = o.apply(r, e)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function g(r) {
  return a(this, null, function* () {
    const {
      data: e
    } = yield f.get(
      "/bsplatform/commodity/getMarketLineAttributeColumn",
      { params: r }
    );
    return e == null ? void 0 : e.data;
  });
}
export {
  g as getGetMarketLineAttributeColumn
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bsplatform/commodity/getMarketLineAttributeColumn/get.js
// module id = 1797
// module chunks = 67